import BlinketLogo from 'assets/images/new-logo-blinket.svg';
import PrintContext from 'components/Pages/Public/Participant/Content/Ticket/context';
import React, { useContext } from 'react';

const Header = () => {
  const { isPrinting } = useContext(PrintContext);

  return (
    <div className={isPrinting ? 'noprint2' : ''}>
      <img height={32} src={BlinketLogo} alt='Logo Eduzz' />
    </div>
  );
};

export default Header;
